import { StateType } from 'data/types'

export const get = (state: StateType) => state.auth.ukFrictions.data
